<template>
  <div>
    <el-card class="box-card box-cards" shadow="never">
      <el-row>
        <el-form :inline="true" class="user-search">
          <el-col :span="24">
            <el-form-item>
              <div class="card_top"><span>兑换列表</span></div>
            </el-form-item>
            <el-form-item label="搜索：">
              <el-input size="small" v-model="formInline.params.receiverNameLike" placeholder="输入关键字"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </el-card>
    <el-card class="box-card box-cards2" shadow="never">
      <!--列表-->
      <el-table border ref="multipleTable" :data="tableData" :header-cell-style="headStyle" tooltip-effect="dark"
        style="width: 100%; " v-loading="loading">
        <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="userId" label="用户ID" align="center" width="120"></el-table-column>
        <el-table-column prop="ranking" label="	排名" align="center" width="140">
          <template slot-scope="scope">
            <div>第 {{ scope.row.rankId }} 期 第 {{ scope.row.ranking }} 名</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverName" label="收件人" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.receiverName }}</div>
            <div>{{ scope.row.receiverPhone }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="receiverAddress" label="收件人地址" align="center"></el-table-column>
        <el-table-column prop="is_show" label="状态" align="center" width="140">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status < 1" type="info" size="small">已失效</el-tag>
            <el-tag v-else-if="scope.row.status < 2" size="small">待领奖</el-tag>
            <el-tag v-else-if="scope.row.status < 3" type="danger" size="small">待发货</el-tag>
            <el-tag v-else-if="scope.row.status < 4" type="warning" size="small">待收货</el-tag>
            <el-tag v-else type="success" size="small">已完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="jtime" label="更新时间" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.createTime | timestampToTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="shippingCompany" label="发货信息" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.shippingCompany }}</div>
            <div>{{ scope.row.trackingNumber }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.isShipped == 0" size="mini" type="primary"
              @click="handleEdit(scope.$index, scope.row)">发货</el-button>
            <el-button v-else size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-card>
    <el-drawer :title="title" :visible.sync="editFormVisible" :before-close="handleClose" direction="rtl"
      custom-class="demo-drawer" ref="drawer" size="30%">
      <div class="demo-drawer__content">
        <el-row>
          <el-form label-width="110px" :model="editForm" :rules="rules" ref="editForm">
            <el-col :span="22">
              <div class="grid-content bg-purple">

                <el-form-item label="物流公司:" prop="name">
                  <el-input v-model="editForm.params.shippingCompany" placeholder="请输入物流公司"></el-input>
                </el-form-item>
                <el-form-item label="物流单号:" prop="name">
                  <el-input v-model="editForm.params.trackingNumber" placeholder="请输入物流单号"></el-input>
                </el-form-item>

              </div>
            </el-col>

          </el-form>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="handleClose">取消</el-button>
          <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">
            保存</el-button>
        </div>
        <div style="height: 60px; margin-top: 50px"></div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Pagination from "../../components/Pagination";
import debounce from "../../utils/debounce";
import { shippinglist, shippingupdate } from "../../api/userMG";
export default {
  data() {
    return {
      title: "信息",
      options: [],
      editFormVisible: false,
      //分页
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      tableData: [], //表格数据 
      formInline: {
        data: {},
        params: {
          pageNum: 1,
          pageSize: 10,
          receiverNameLike: ""
        },
      },
      dialogImageUrl: '',
      dialogVisible: false,
      //添加，修改数据
      editForm: {
        data: {},
        params: {
          "id": 1,
          "trackingNumber": "",
          "shippingCompany": ""
        },
      },
      //规则验证
      rules: {},
    };
  },
  components: {
    Pagination
  },
  created() {
    //数据列表
    this.getlist(this.formInline);
  },
  methods: {
    headStyle() {
      return {
        background: "#A1BBFF",
        color: "#fff",
        letterSpacing: "2px",
        border: " 1px solid #A1BBFF",
        textAlign: "center",
        height: "39px",
      };
    },

    //显示数据
    getlist(parameter) {
      this.loading = true;
      shippinglist(parameter)
        .then((res) => {
          this.loading = false;
          // console.log("userlist", res);
          if (res.code != 200) {
            this.$message({
              type: "info",
              message: res.message,
            });
          } else {
            this.tableData = res.data.records;
            // 分页赋值
            this.pageparm.currentPage = this.formInline.params.pageNum;
            this.pageparm.pageSize = this.formInline.params.pageSize;
            this.pageparm.total = res.data.total;
            // console.log(this.tableData)
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.params.pageNum = parm.currentPage;
      this.formInline.params.pageSize = parm.pageSize;
      this.getlist(this.formInline);
    },
    // 搜索事件
    search() {
      this.formInline.params.pageNum = 1;
      this.getlist(this.formInline); //显示
    },
    //关闭弹框
    handleClose(done) {
      this.$confirm("还有未保存的工作哦确定关闭吗？")
        .then((_) => {
          this.editFormVisible = false
          // done();
        })
        .catch((_) => { });
    },
    //上传头像


    //添加，修改
    handleEdit(index, row) {
      this.editFormVisible = true;
      this.editForm = {

        data: {},
        params: {
          "id": row.id,
          "trackingNumber": row.trackingNumber,
          "shippingCompany": row.shippingCompany,
        },
      }


    },
    //提交添加，修改
    submitForm(info) {

      debounce(() => {

        shippingupdate(this.editForm)
          .then(res => {
            if (res.code == 200) {
              this.editFormVisible = false;
              this.getlist(this.formInline);
              this.$message({
                message: "保存成功！",
                type: "success",
              });
            } else {
              this.$message({
                type: "info",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.editFormVisible = false;
            this.$message.error("保存失败，请稍后再试！");
          });



      }, 1500);
    },

  },
};
</script>
<style>
@import "../../assets/css/index.css";

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.divBox {
  /*flex-direction: row;*/
  float: left;
  position: relative;
  margin-right: 10px;
}

.imgSty {
  margin-left: 3px;
}

.delIcon {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 145px;
  height: 145px;
  line-height: 145px;
  text-align: center;
}

.avatar {
  width: 145px;
  height: 145px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/shipping/list.vue